<template>
  <v-card class="blue-grey darken-4 d-flex flex-column" flat tile>
    <div class="text-right mr-1 mt-1">
      <v-btn dark x-small icon @click="close()">
        <v-icon x-small>mdi-close</v-icon>
      </v-btn>
    </div>
    <h4 class="white--text text-center">
      {{ appTitle }}
    </h4>
    <img class="my-2" :src="AssetsImage" height="40" width="100%" />
    <AlertContainer
      class="overflow-y-auto"
      style="height: calc(100vh - 216px)"
    />
    <v-card
      class="mx-2 my-2 pa-1 white--text blue-grey darken-2"
      height="90"
      width="320"
      tile
    >
      <h5>お知らせ</h5>
      <div
        class="caption"
        style="overflow-y: scroll; height: 60px"
        v-html="sysMsg"
      ></div>
    </v-card>
  </v-card>
</template>

<script>
import axios from "axios";
import AssetsImage from "@/assets/LogoLarge.svg";
import AlertContainer from "./AlertContainer";
export default {
  name: "RightSideContents",
  components: {
    AlertContainer
  },
  data() {
    return {
      sysMsg: null,
      AssetsImage
    };
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE;
    }
  },
  mounted() {
    this.loadSystemMessage();
  },
  methods: {
    close() {
      this.$store.commit("SET_IS_RIGHT_NAV", false);
    },
    async loadSystemMessage() {
      this.sysMsg = null;
      const domain = process.env.VUE_APP_DOMAIN;
      const response = await axios
        .create({
          responseType: "json"
        })
        .get(`https://${domain}/sys_msg.json`);
      if (response.data && response.data.html) {
        this.sysMsg = response.data.html;
      }
    }
  }
};
</script>

<style lang="scss">
//
</style>
